import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const Renderer = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "forge-renderer" */ './renderer')),
    LoadingSkeleton: () => null,
});
